import { Component, Input, OnInit } from '@angular/core';
import * as QRCode from 'qrcode';
import { UtilitiesService } from 'src/app/utilities/utilities.service';

@Component({
  selector: 'app-esim-qr-code',
  templateUrl: './esim-qr-code.component.html',
  styleUrls: ['./esim-qr-code.component.scss']
})
export class EsimQRCodeComponent implements OnInit {
  @Input() activationCode:any;
  qrCodeImage: any;
  ENV: any;
  constructor(private UTS: UtilitiesService) { }

  ngOnInit(): void {
    this.generateQRCode()
    this.ENV = localStorage.getItem('ENV');
  }

  generateQRCode(): void {
    QRCode.toDataURL(this.activationCode, (err, url) => {
      if (err) {
        console.error(err);
      } else {
        this.qrCodeImage = url;
      }
    });
  }
  shareQRCodeImage(){
    const OS = this.UTS.getMobileOperatingSystem();
    const payload = {
      qrCodeImage: this.qrCodeImage.split("base64,")[1],
    };
    if (this.ENV == 'mobile' && OS == 'Android') {
      (window as any).deals.shareQrCode(JSON.stringify(payload));
    } else if (this.ENV == 'mobile' && OS == 'iOS') {
      const messgeToPost = {
        method: 'shareQrCode',
        payload: JSON.stringify(payload)
      };
      (window as any).webkit.messageHandlers.hybridInterface.postMessage(
        JSON.stringify(messgeToPost)
      );
    }
  }
  downloadQRCode() {
    const OS = this.UTS.getMobileOperatingSystem();
    const payload = {
      qrCodeImage: this.qrCodeImage.split("base64,")[1],
    };
    if (this.ENV == 'mobile' && OS == 'Android') {
      (window as any).deals.downloadQrCode(JSON.stringify(payload));

    } else if (this.ENV == 'mobile' && OS == 'iOS') {
      const messgeToPost = {
        method: 'downloadQrCode',
        payload: JSON.stringify(payload)
      };
      (window as any).webkit.messageHandlers.hybridInterface.postMessage(
        JSON.stringify(messgeToPost)
      );
    }else{
      const link = document.createElement('a');
      link.href = this.qrCodeImage;
      link.download = 'qrcode.png';
      link.click();
      document.body.removeChild(link);
    }
  }
}
